import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-subscription-record",
  "use": "icon-subscription-record-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-subscription-record\"><path d=\"M879.9 29.8C859.4 11.3 831.2 0 800.5 0H223.6c-30.8 0-58.9 11.5-79.4 29.8-20.8 18.8-33.7 44.6-33.7 73.3v886.8h0.1c0 6 1.7 11.9 5.2 17.4 10.3 16.1 32.7 21.5 50 11.7l324.9-181.4c6.6-3.8 14-5.6 21.4-5.6 7.4 0 14.7 1.8 21.4 5.6L856 1017.8c6 3.9 13.2 6.2 21 6.2 20.1 0 36.5-15.2 36.5-34.1V103c0.2-28.6-12.8-54.5-33.6-73.2zM719.3 319.4H304.8c-27 0-48.8-21.9-48.8-48.8 0-27 21.9-48.8 48.8-48.8h414.5c27 0 48.8 21.9 48.8 48.8s-21.8 48.8-48.8 48.8z\" p-id=\"14887\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/subscription-record.svg
// module id = BI1p
// module chunks = 65